import { get } from '../client/client';
import { endpoint } from '../endpoint';
import type {
  AttentionItemPublic,
  DashboardListResponse,
  DashboardSummaryResponse,
  RecentTransactionPublic,
} from '../type/dashboard';

export const getDashboardSummary = async () => {
  return await get<DashboardSummaryResponse>(endpoint.getDashboardSummary);
};

export const getDashboardTransactions = async () => {
  return await get<DashboardListResponse<RecentTransactionPublic>>(endpoint.getDashboardTransactions);
};

export const getDashboardAttention = async () => {
  return await get<DashboardListResponse<AttentionItemPublic>>(endpoint.getDashboardAttention);
};
